// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthLogoutRouteImport } from './routes/auth/logout'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as ProtectedMapRouteImport } from './routes/_protected/map'
import { Route as ProtectedHomeRouteImport } from './routes/_protected/home'
import { Route as ProtectedGroupRouteImport } from './routes/_protected/group'
import { Route as ProtectedGenerateRouteImport } from './routes/_protected/generate'
import { Route as ProtectedCampaignsIndexRouteImport } from './routes/_protected/campaigns.index'
import { Route as ProtectedCampaignsCampaignIdRouteImport } from './routes/_protected/campaigns.$campaignId'

const ProtectedRoute = ProtectedRouteImport.update({
            id: '/_protected',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthLogoutRoute = AuthLogoutRouteImport.update({
            id: '/auth/logout',path: '/auth/logout',getParentRoute: () => rootRouteImport
          })
const AuthLoginRoute = AuthLoginRouteImport.update({
            id: '/auth/login',path: '/auth/login',getParentRoute: () => rootRouteImport
          })
const ProtectedMapRoute = ProtectedMapRouteImport.update({
            id: '/map',path: '/map',getParentRoute: () => ProtectedRoute
          })
const ProtectedHomeRoute = ProtectedHomeRouteImport.update({
            id: '/home',path: '/home',getParentRoute: () => ProtectedRoute
          })
const ProtectedGroupRoute = ProtectedGroupRouteImport.update({
            id: '/group',path: '/group',getParentRoute: () => ProtectedRoute
          })
const ProtectedGenerateRoute = ProtectedGenerateRouteImport.update({
            id: '/generate',path: '/generate',getParentRoute: () => ProtectedRoute
          })
const ProtectedCampaignsIndexRoute = ProtectedCampaignsIndexRouteImport.update({
            id: '/campaigns/',path: '/campaigns/',getParentRoute: () => ProtectedRoute
          })
const ProtectedCampaignsCampaignIdRoute = ProtectedCampaignsCampaignIdRouteImport.update({
            id: '/campaigns/$campaignId',path: '/campaigns/$campaignId',getParentRoute: () => ProtectedRoute
          })





const ProtectedRouteChildren = {
  ProtectedGenerateRoute: ProtectedGenerateRoute,ProtectedGroupRoute: ProtectedGroupRoute,ProtectedHomeRoute: ProtectedHomeRoute,ProtectedMapRoute: ProtectedMapRoute,ProtectedCampaignsCampaignIdRoute: ProtectedCampaignsCampaignIdRoute,ProtectedCampaignsIndexRoute: ProtectedCampaignsIndexRoute
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(ProtectedRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,ProtectedRoute: ProtectedRouteWithChildren,AuthLoginRoute: AuthLoginRoute,AuthLogoutRoute: AuthLogoutRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)